<div class="process-list">
    <div class="grid">
        <ng-container *ngFor="let process of processes">
            <ng-container *ngIf="process.ProcessResourceImage && process.ImageOnly">
                <div *ngIf="!process.ProcessUrl" class="col-12">
                    <img
                        (click)="goto(process)"
                        [alt]="process.ProcessTitle"
                        [title]="process.ProcessDesc"
                        [src]="process.ProcessResourceImage"
                        class="qb-process-item w-full col-12"
                    />
                </div>
                <a
                    class="col-12"
                    *ngIf="process.ProcessUrl"
                    [href]="process.ProcessUrl"
                    [target]="process.target ?? '_self'"
                    rel="noopener"
                >
                    <img
                        [alt]="process.ProcessTitle"
                        [title]="process.ProcessDesc"
                        [src]="process.ProcessResourceImage"
                        class="qb-process-item w-full col-12"
                    />
                </a>
            </ng-container>
        </ng-container>
        <!-- <button
            pButton
            type="button"
            class="ml-1 bg-teal-600 p-button-raised w-full border-none"
            label="Reports"
            icon="pi pi-chart-bar"
            (click)="this.app.onReportButtonClick($event)"
        ></button> -->
        <ng-container *ngFor="let item of processes">
            <ef-process
                class="col-12 sm:col-6 md:col-6 lg:col-6 xl:col-6"
                [catId]="category.CategoryId"
                [process]="item"
                *ngIf="!item.ImageOnly"
            ></ef-process>
        </ng-container>
    </div>
</div>
